<template>
	<div :class="['c-popup', { active: showMenu }]">
		<transition>
			<div class="c-popup__inner">
				<slot name="links">
					<!-- <router-link to="/profile" v-if="user && user.avatar">
						<img
							:title="`${user.name}'s profile`"
							:src="`${assetUrl}/${user.avatar.name}`"
						/>
						<article>
							<p>{{ user.name }} {{ user.lastName }}</p>
							<span>
								{{ user.email }}
							</span>
						</article>
					</router-link> -->
					<h6>Links</h6>
					<ul>
						<li>
							<router-link to="/profile" class="btn">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M4 18.8C4 16.149 6.14903 14 8.8 14H15.2C17.851 14 20 16.149 20 18.8V18.8C20 20.5673 18.5673 22 16.8 22H7.2C5.43269 22 4 20.5673 4 18.8V18.8Z"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								Settings
							</router-link>
						</li>
						<li>
							<router-link to="/help" class="btn">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M19.0711 4.92893L19.6014 4.3986L19.0711 4.92893ZM14.4697 8.46967C14.1768 8.76256 14.1768 9.23744 14.4697 9.53033C14.7626 9.82322 15.2374 9.82322 15.5303 9.53033L14.4697 8.46967ZM9.53033 15.5303C9.82322 15.2374 9.82322 14.7626 9.53033 14.4697C9.23744 14.1768 8.76256 14.1768 8.46967 14.4697L9.53033 15.5303ZM8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033C9.82322 9.23744 9.82322 8.76256 9.53033 8.46967L8.46967 9.53033ZM15.5303 14.4697C15.2374 14.1768 14.7626 14.1768 14.4697 14.4697C14.1768 14.7626 14.1768 15.2374 14.4697 15.5303L15.5303 14.4697ZM12 21.25C9.44548 21.25 7.134 20.2155 5.45926 18.5407L4.3986 19.6014C6.34315 21.5459 9.03168 22.75 12 22.75V21.25ZM5.45926 18.5407C3.78452 16.866 2.75 14.5545 2.75 12H1.25C1.25 14.9683 2.45406 17.6569 4.3986 19.6014L5.45926 18.5407ZM21.25 12C21.25 14.5545 20.2155 16.866 18.5407 18.5407L19.6014 19.6014C21.5459 17.6569 22.75 14.9683 22.75 12H21.25ZM18.5407 18.5407C16.866 20.2155 14.5545 21.25 12 21.25V22.75C14.9683 22.75 17.6569 21.5459 19.6014 19.6014L18.5407 18.5407ZM12 2.75C14.5545 2.75 16.866 3.78452 18.5407 5.45926L19.6014 4.3986C17.6569 2.45406 14.9683 1.25 12 1.25V2.75ZM18.5407 5.45926C20.2155 7.134 21.25 9.44548 21.25 12H22.75C22.75 9.03168 21.5459 6.34315 19.6014 4.3986L18.5407 5.45926ZM2.75 12C2.75 9.44548 3.78452 7.134 5.45926 5.45926L4.3986 4.3986C2.45406 6.34315 1.25 9.03168 1.25 12H2.75ZM5.45926 5.45926C7.134 3.78452 9.44548 2.75 12 2.75V1.25C9.03168 1.25 6.34315 2.45406 4.3986 4.3986L5.45926 5.45926ZM18.5407 4.3986L14.4697 8.46967L15.5303 9.53033L19.6014 5.45926L18.5407 4.3986ZM8.46967 14.4697L4.3986 18.5407L5.45926 19.6014L9.53033 15.5303L8.46967 14.4697ZM4.3986 5.45926L8.46967 9.53033L9.53033 8.46967L5.45926 4.3986L4.3986 5.45926ZM14.4697 15.5303L18.5407 19.6014L19.6014 18.5407L15.5303 14.4697L14.4697 15.5303ZM15.25 12C15.25 13.7949 13.7949 15.25 12 15.25V16.75C14.6234 16.75 16.75 14.6234 16.75 12H15.25ZM12 15.25C10.2051 15.25 8.75 13.7949 8.75 12H7.25C7.25 14.6234 9.37665 16.75 12 16.75V15.25ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75V7.25C9.37665 7.25 7.25 9.37665 7.25 12H8.75ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12H16.75C16.75 9.37665 14.6234 7.25 12 7.25V8.75Z"
										fill="currentColor"
									/>
								</svg>

								Help & Support
							</router-link>
						</li>
						<li>
							<a @click.prevent="onLogout" href="#" class="btn">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12 2V12M16 4.93555C18.9634 6.40825 21 9.46631 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.46631 5.03656 6.40825 8 4.93555"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
									/>
								</svg>
								Logout
							</a>
						</li>
					</ul>
					<h6>Supported ad libraries</h6>
					<ul>
						<li>
							<a
								class="btn"
								href="https://www.facebook.com/ads/library"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>

								Facebook Ad Library
							</a>
						</li>
						<li>
							<a class="btn" href="https://www.instagram.com" target="_blank">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>

								Instagram organic
							</a>
						</li>
						<li>
							<a class="btn" href="https://tiktok.com" target="_blank">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Tiktok organic
							</a>
						</li>
						<li>
							<a
								class="btn"
								href="https://ads.tiktok.com/business/creativecenter"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Tiktok Creative Center
							</a>
						</li>
						<li>
							<a
								class="btn"
								href="https://library.tiktok.com/ads"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Tiktok Ad Library(EU only)
							</a>
						</li>
						<li>
							<a
								class="btn"
								href="https://www.linkedin.com/ad-library/home"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Linkedin Ad Library
							</a>
						</li>
					</ul>
					<span class="small">
						You can save Ads from the above Ad Libraries via our Chrome
						extension.
					</span>
				</slot>
			</div>
		</transition>
	</div>
</template>

<script>
import Popup from '@swipekit/components/popup';
import Avatar from './avatar';
import ExtensionStatus from './extension-status';

export default {
	components: {
		Avatar,
		Popup,
		ExtensionStatus,
	},

	data: function () {
		return {
			offset: [0, 32],
			init: false,
			popup: false,
			showMenu: false,
		};
	},

	props: {
		menu: {},
	},

	computed: {
		user: function () {
			return this.$store.getters['users/user'];
		},
		menuTarget: function () {
			return this.menu;
		},
	},

	methods: {
		onLogout: function () {
			this.showMenu = false;
			// add a small delay for ux purposes
			setTimeout(() => {
				this.$store.dispatch('users/logout');
			}, 50);
		},
		onBoardClick: function () {
			this.$store.dispatch('app/toggleSidebar');
		},
		toggleMenu: function () {
			this.$nextTick(() => {
				this.showMenu = !this.showMenu;
			});
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
	},
};
</script>

<style lang="scss">
.c-popup {
	position: absolute;
	top: 42px;
	left: var(--margin);
	width: calc(100% - var(--margin) * 2);
	height: auto;
	background: transparent;
	pointer-events: none;
	box-shadow: none;

	&__arrow {
		//display: none;
		color: var(--color-bg-99);
	}

	&__inner {
		pointer-events: none;
		background: var(--color-bg-99);
		border-radius: var(--border-radius-lg);
		box-shadow: var(--box-shadow);

		> a {
			display: grid;
			grid-template-columns: 32px 1fr;
			align-items: center;
			padding: 0 var(--margin-lg);
			padding-top: var(--margin);
			color: #ededed;
			text-decoration: none !important;

			img {
				width: 32px;
				height: 32px;
				border-radius: 99px;
				object-fit: cover;
				object-position: center center;
			}

			> article {
				padding: var(--margin);

				p {
					margin: 0;
					line-height: 1.3;
				}

				span {
					display: block;
					padding: 0;
					line-height: 1.1;
				}
			}
		}

		span {
			display: inline-block;
			padding: var(--spacer-sm);
			padding-top: var(--margin);
			font-size: var(--font-size-xs);
			color: #ededed;
			opacity: 0.6;
		}
	}

	h6 {
		color: #c5c5c5;
		padding: var(--margin-lg) 12px 0 12px;
		margin: 0;
	}

	ul {
		width: 100%;
		display: inline-block;
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			margin: var(--margin);

			.btn {
				width: 100%;
				justify-content: flex-start;
			}
		}
	}

	.btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: var(--margin);
		margin-right: var(--margin);
		background-color: rgba(255, 255, 255, 0);
		border-radius: 5px;
		font-size: var(--font-size-sm);
		color: #ededed;
		line-height: 1;

		svg {
			width: 18px;
			height: 18px;
			margin-right: var(--margin);
			color: #fff;
		}

		&:hover,
		&:active,
		&.active {
			box-shadow: none !important;
			background-color: var(--color-bg-96) !important;
			color: #fff;
		}

		&:focus {
			box-shadow: none !important;
		}
	}

	&.active {
		.c-popup__inner {
			pointer-events: all;
		}
	}
}
</style>
